/**
 * Retail storefront (not business.countrylifefoods.com):
 * 1) Patch fetch so /products/*.js JSON drops B2B selling_plan_allocations before subscription apps read them.
 * 2) Remove stray B2B <option>s if any widget uses a native <select>.
 *
 * Aligns with clnf-purchase-options.liquid (Subscribe & Save 5% / "deliver every…" vs B2B "delivered every…").
 */
(function () {
  'use strict';

  var B2B_HOST = 'business.countrylifefoods.com';

  function isRetailHost() {
    return (
      typeof window.location !== 'undefined' &&
      window.location.hostname !== B2B_HOST
    );
  }

  function optionLabelAllowed(text) {
    var raw = (text || '').trim();
    if (!raw) return false;
    var lower = raw.toLowerCase();
    if (/\bone[-\s]?time\b/i.test(lower)) return true;
    if (lower.indexOf('5%') !== -1) return true;
    if (/^deliver every/i.test(raw)) return true;
    if (/^delivered every/i.test(raw)) return false;
    return false;
  }

  function filterVariantAllocations(variant) {
    if (
      !variant ||
      !variant.selling_plan_allocations ||
      !Array.isArray(variant.selling_plan_allocations)
    ) {
      return;
    }
    variant.selling_plan_allocations = variant.selling_plan_allocations.filter(
      function (alloc) {
        var name =
          (alloc.selling_plan && alloc.selling_plan.name) ||
          (alloc.selling_plan && alloc.selling_plan.description) ||
          '';
        return optionLabelAllowed(name);
      }
    );
  }

  function filterProductJsonData(data) {
    if (!data || typeof data !== 'object') return;
    var i;
    if (Array.isArray(data.variants)) {
      for (i = 0; i < data.variants.length; i++) {
        filterVariantAllocations(data.variants[i]);
      }
    }
    if (data.product && typeof data.product === 'object') {
      filterProductJsonData(data.product);
    }
    if (Array.isArray(data.products)) {
      for (i = 0; i < data.products.length; i++) {
        filterProductJsonData(data.products[i]);
      }
    }
  }

  function shouldFilterProductAjaxUrl(url) {
    try {
      var s = typeof url === 'string' ? url : url && url.url;
      if (!s) return false;
      var path = s.split(/[?#]/)[0];
      if (path.indexOf('/products/') === -1) return false;
      if (path.slice(-3) !== '.js') return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  if (isRetailHost() && typeof window.fetch === 'function' && !window.__clnfRetailPlanFetchPatched) {
    window.__clnfRetailPlanFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var urlStr = typeof input === 'string' ? input : input && input.url;
      var out = origFetch.apply(this, arguments);
      if (!shouldFilterProductAjaxUrl(urlStr)) return out;
      return out.then(function (res) {
        if (!res || typeof res.clone !== 'function' || !res.ok) return res;
        return res
          .clone()
          .json()
          .then(function (data) {
            try {
              filterProductJsonData(data);
            } catch (e) {}
            return new Response(JSON.stringify(data), {
              status: res.status,
              statusText: res.statusText,
              headers: res.headers,
            });
          })
          .catch(function () {
            return res;
          });
      });
    };
  }

  if (!isRetailHost()) return;

  function collectSelectsDeep(root, out) {
    if (!root) return;
    var tag = root.tagName;
    if (tag === 'SELECT') {
      out.push(root);
      return;
    }
    if (root.shadowRoot) {
      collectSelectsDeep(root.shadowRoot, out);
    }
    var ch = root.children;
    if (!ch) return;
    var i;
    for (i = 0; i < ch.length; i++) {
      collectSelectsDeep(ch[i], out);
    }
  }

  function looksLikeSellingPlanSelect(select) {
    if (!select || select.tagName !== 'SELECT') return false;
    if (select.options.length < 2) return false;
    var hits = 0;
    var i;
    for (i = 0; i < select.options.length; i++) {
      var t = (select.options[i].textContent || '').toLowerCase();
      if (
        /\bone[-\s]?time\b/i.test(t) ||
        t.indexOf('deliver') !== -1 ||
        /every\s+\d/.test(t) ||
        (t.indexOf('month') !== -1 && t.indexOf('every') !== -1) ||
        (t.indexOf('week') !== -1 && t.indexOf('every') !== -1)
      ) {
        hits++;
      }
    }
    return hits >= 2;
  }

  function fingerprint(select) {
    var parts = [];
    var i;
    for (i = 0; i < select.options.length; i++) {
      parts.push(select.options[i].value + '\t' + select.options[i].textContent);
    }
    return parts.join('\n');
  }

  function filterOneSelect(select) {
    if (!looksLikeSellingPlanSelect(select)) return;

    var prevValue = select.value;
    var toRemove = [];
    var i;
    for (i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      if (!optionLabelAllowed(opt.textContent)) toRemove.push(opt);
    }
    if (!toRemove.length) return;

    for (i = 0; i < toRemove.length; i++) {
      toRemove[i].remove();
    }

    var afterFp = fingerprint(select);
    if (select.getAttribute('data-clnf-selling-filter-fp') === afterFp) return;
    select.setAttribute('data-clnf-selling-filter-fp', afterFp);

    var stillHas = false;
    for (i = 0; i < select.options.length; i++) {
      if (select.options[i].value === prevValue) {
        stillHas = true;
        break;
      }
    }

    if (!stillHas && select.options.length) {
      var preferred = null;
      for (i = 0; i < select.options.length; i++) {
        var tx = (select.options[i].textContent || '').toLowerCase();
        if (/\bone[-\s]?time\b/i.test(tx)) {
          preferred = select.options[i];
          break;
        }
      }
      if (!preferred) preferred = select.options[0];
      select.value = preferred.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function filterAllDom() {
    var out = [];
    collectSelectsDeep(document.documentElement, out);
    var s;
    for (s = 0; s < out.length; s++) {
      try {
        filterOneSelect(out[s]);
      } catch (e) {}
    }
  }

  function mutationsTouchSelect(mutations) {
    var m, i, n, added;
    for (m = 0; m < mutations.length; m++) {
      added = mutations[m].addedNodes;
      for (i = 0; i < added.length; i++) {
        n = added[i];
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'SELECT') return true;
        if (typeof n.querySelector === 'function' && n.querySelector('select')) return true;
      }
    }
    return false;
  }

  var scheduled = null;
  function scheduleFilter() {
    if (scheduled) return;
    scheduled = window.setTimeout(function () {
      scheduled = null;
      filterAllDom();
    }, 100);
  }

  // A selling-plan <select> can only render inside the cart drawer or a product's details column
  // (buy buttons + subscription app blocks, also used by quick add) - never in the header, footer
  // or grids. Observing only those containers avoids running mutationsTouchSelect on every
  // unrelated DOM mutation site-wide (this file loads on every retail page).
  var observedRoots = [];
  function getSellingPlanRoots() {
    var roots = [];
    var nodes = document.querySelectorAll('cart-drawer-component, .product-details, product-form-component');
    var i, j, nested;
    for (i = 0; i < nodes.length; i++) {
      nested = false;
      for (j = 0; j < roots.length; j++) {
        if (roots[j].contains(nodes[i])) {
          nested = true;
          break;
        }
      }
      if (!nested) roots.push(nodes[i]);
    }
    return roots;
  }

  function observeSellingPlanRoots(mo) {
    var roots = getSellingPlanRoots();
    var i, r;
    observedRoots = observedRoots.filter(function (node) {
      return node.isConnected;
    });
    for (i = 0; i < roots.length; i++) {
      r = roots[i];
      if (observedRoots.indexOf(r) !== -1) continue;
      try {
        mo.observe(r, { childList: true, subtree: true });
        observedRoots.push(r);
      } catch (e) {}
    }
  }

  function bootDom() {
    scheduleFilter();
    var mo = null;
    try {
      mo = new MutationObserver(function (mutations) {
        if (mutationsTouchSelect(mutations)) scheduleFilter();
      });
      observeSellingPlanRoots(mo);
    } catch (e) {}

    // Section re-renders (Theme Editor, quick add modal, cart drawer refresh) can replace the
    // observed nodes; re-attach to new instances and re-filter.
    function refresh() {
      if (mo) observeSellingPlanRoots(mo);
      scheduleFilter();
    }
    document.addEventListener('shopify:section:load', refresh);
    // Horizon's dialog:open does not bubble; capture it from the cart drawer / quick add modal.
    document.addEventListener('dialog:open', refresh, true);
    document.addEventListener('cart:update', refresh);
    document.addEventListener('variant:update', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootDom);
  } else {
    bootDom();
  }
})();
